import React, { useContext } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { ResultsMenuStoreContext } from "@state/context/results";
import classnames from "classnames";

export default observer(function DayTabs() {
	const { t } = useTranslation();
	const { selectedTournaments, resultsDataStore } = useContext(
		ResultsMenuStoreContext
	);
	const { searchPhrase, hasPendingRequest, resultData } = resultsDataStore;

	if (
		searchPhrase ||
		selectedTournaments.length ||
		hasPendingRequest ||
		!resultData
	) {
		return null;
	}

	const { dayParam, selectDay } = resultsDataStore;

	const todayTabClasses = classnames("tabs--primary__item", {
		"is-active": dayParam === 0,
	});
	const yesterdayTabClasses = classnames("tabs--primary__item", {
		"is-active": dayParam === -1,
	});

	return (
		<div className="card--primary__tabs">
			<nav className="tabs--primary">
				<div className={todayTabClasses} onClick={() => selectDay(0)}>
					{t("RESULTS.RESULT_CONTENT.TODAY")}
				</div>
				<div
					className={yesterdayTabClasses}
					onClick={() => selectDay(-1)}
				>
					{t("RESULTS.RESULT_CONTENT.YESTERDAY")}
				</div>
			</nav>
		</div>
	);
});
